/* eslint-disable react/display-name */
import * as React from 'react';

const Menu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M16,13v.14a1.18,1.18,0,0,1-1.29,1H1.29a1.12,1.12,0,0,1-1.29-1v-.13A1.18,1.18,0,0,1,1.29,12H14.71A1.18,1.18,0,0,1,16,13Zm0-5.11v.14a1.18,1.18,0,0,1-1.29,1H1.29A1.18,1.18,0,0,1,0,8.07V7.93a1.17,1.17,0,0,1,1.29-1H14.71A1.17,1.17,0,0,1,16,7.93Zm0-5.11V3A1.17,1.17,0,0,1,14.71,4H1.29A1.17,1.17,0,0,1,0,3V2.82a1.17,1.17,0,0,1,1.29-1H14.71A1.17,1.17,0,0,1,16,2.82Z"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export default Menu;
